<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="昵称或手机">
          <el-input v-model="formInline.nickName" placeholder="请输入昵称或手机"></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="formInline.scene" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item,index) in Scene" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange">
          <el-table-column prop="id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="user" label="微信头像" width="70">
            <template slot-scope="scope" v-if="scope.row.user">
              <img :src="scope.row.user.avatarUrl" width="60" height="60" />
            </template>
          </el-table-column>
          <el-table-column prop="user.nickName" label="用户">
            <template slot-scope="scope" v-if="scope.row.user">
              <p>用户ID：{{scope.row.user.user_id}}</p>
              <p>等级：{{grade[scope.row.user.grade_id]['name']}}</p>
              <p>昵称：{{scope.row.user.nickName}}</p>
              <p v-if="scope.row.user.mobile">手机：{{scope.row.user.mobile}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="log_type.text" label="类型" width="120" align="center"></el-table-column>
          <el-table-column prop="price" label="金额" width="120" align="center" sortable="custom"></el-table-column>
          <el-table-column prop="params" label="备注">
            <template slot-scope="scope">
               <p>{{scope.row.remark}}</p>
              <div v-if="scope.row.order_id>0">
                <p><span class="gray9 mr10">订单号：</span>{{scope.row.order_params.order_no}} <el-button size="mini" href="/" target="_blank" @click="gotoPage(scope.row)">订单详情</el-button></p>
                <p><span class="gray9">支付金额：</span>{{scope.row.order_params.pay_price}}</p>
                <p><span class="gray9">昵称：</span>{{scope.row.order_params.nick_name}}</p>
                <p><span class="gray9">手机：</span>{{scope.row.order_params.phone}}</p>
              </div>
              <div v-if="scope.row.params">
                <p v-for="(v, i) in scope.row.params" :key="i">
                  <span class="gray9">{{ v.msg }}：</span>{{ v.val }}
                </p>
              </div>              
            </template>
          </el-table-column>
          <el-table-column prop="is_settled" label="是否结算" width="130">
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.is_settled">已结算</span>
              <span class="gray9" v-else>未结算</span>
            </template>
          </el-table-column>
          <el-table-column prop="settle_time" label="结算时间" width="140" sortable="custom"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="140" sortable="custom"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {

    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          nickName: '',
          user_id: '',
          scene: '',
          create_time: ''
        },
        /*场景*/
        Scene: [],
        /*时间*/
        create_time: '',
        /*等级*/
        grade:[],
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formInline, params);

      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*跳转订单详情*/
      gotoPage(row) {
        let self = this;
        this.$router.push({
          path: '/order/order/detail',
          query: {
            order_id: row.order_id
          }
        });
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        UserApi.AgentLog(Params, true).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.Scene = data.data.attributes;
          self.grade = data.data.grade;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/agent/part/Log.vue